import * as durationHelper from '../../helpers/duration-handler';
import * as transitionHelper from '../../helpers/transition-handler';
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';
import { HTTP_GO } from '../../core/http/http-go-token';
import service from '../../services/index';
import i18n from '../../i18n';
const state = {
  fromRouteAdd: true,
  fromRouteBiblio: false,
  Auteurs: [],
  themes: [],
  selectedSegments: [],
  current: {},
  loading: false,
  duplicatedSegment:null,
  duplicatedSlideInSegment:null,


  moduleSelected:[],

  currentPage: {
    Segment: 1,
    DefaultSegment: 1,
  },
  theme: 0,
  author: 0,
  title: '',
  nbPerPage: 32,
  endReached: {
    Segment: false,
    DefaultSegment: false,
  },
  generic: {
    start: {},
    end: {},
  },
  delay: 0,
  opacity: 100,
  segments: [],
  indexSlideToAdd: 0,
  indexSegmentToAdd: 0,
  indexSegmentSlideToAdd: 0,
  lengthSegmentToAdd: 0,
  nbrCall: 1,
  typeGeneric: '',
  nbSegments: 0,
};

const mutations = {
  pushModuleSelected(state, segment) {
    const date = new Date(segment.duration);
    const duration = Number.isInteger(segment.duration)
      ? segment.duration
      : Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ) / 1000;
    const s = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      ...segment,
      duration,
      originalDuration: duration,
    };
    s.screens = s.screens.map(s => ({
      uid: Math.floor(new Date().valueOf() * Math.random()),
      transition:
        s.options.transition && Object.keys(s.options.transition).length > 0
          ? s.options.transition
          : { in: '', out: '' },
      options: {
        duration: durationHelper.totalSegmentDuration(),
        fullscreenVideo: s.options.fullscreenVideo,
      },
      ...s,
    }));
    const isUpdate = s.isUpdate;
    if (s.isUpdate) {
      delete s.isUpdate;
    }
    state.moduleSelected.push(s);
    if (!!!isUpdate) {
      state.moduleSelected = durationHelper.updateSegmentDuration(state.moduleSelected);
    } else {
      state.moduleSelected = durationHelper.updateSegmentOriginalDuration(state.moduleSelected);
    }
  },
  restModuleSelected(state) {
    state.moduleSelected = [];
  },
  removeFromModuleSelected(state, id) {
    state.moduleSelected = state.moduleSelected.filter(s => s.id !== id);
  },
  updateSegmentTitleInStore(state, data) {
    state.selectedSegments = state.selectedSegments.map(Segment => {
      if (Segment.uid === data.uid) {
        Segment.title = data.title;
      }
      return Segment;
    });
  },
  setCurrentSegmentTitle(state, title) {
    state.current.title = title;
  },
  setTitle(state, title) {
    state.title = title;
  },

  setThemeid(state, id) {
    state.theme = id;
  },
  setAuthorid(state, id) {
    state.author = id;
  },
  resetPage(state, types) {
    state.currentPage[types] = 1;
  },
  setSegments(state, data) {
    state.segments = data;
  },
  pushSegments(state, segments) {
    state.segments = state.segments.concat(segments);
  },
  cancelDelete(state, data) {
    state.segments.splice(data.index, 0, data.segment);
  },

  nbSegments(state, nb) {
    state.nbSegments = nb;
  },
  selectSegment(state, segment) {
    const date = new Date(segment.duration);

    const duration = Number.isInteger(segment.duration)
      ? segment.duration
      : Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        ) / 1000;
    const s = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      ...segment,
      duration,
      originalDuration: duration,
    };
    s.screens = s.screens.map(s => ({
      uid: Math.floor(new Date().valueOf() * Math.random()),
      transition:
        s.options.transition && Object.keys(s.options.transition).length > 0
          ? s.options.transition
          : { in: '', out: '' },
      options: {
        duration: durationHelper.totalSegmentDuration(),
        fullscreenVideo: s.options.fullscreenVideo,
      },
      ...s,
    }));
    const isUpdate = s.isUpdate;
    if (s.isUpdate) {
      delete s.isUpdate;
    }
   /* if (state.indexSegmentToAdd > -1) {
      state.selectedSegments = [
        ...state.selectedSegments.slice(0, state.indexSegmentToAdd),
        s,
        ...state.selectedSegments.slice(state.indexSegmentToAdd),
      ];
      state.indexSegmentToAdd++;
    } else {*/
      state.selectedSegments.push(s);
   // }
 
    if (!!!isUpdate) {
      state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    } else {
      state.selectedSegments = durationHelper.updateSegmentOriginalDuration(state.selectedSegments);
    }
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setfromRouteAdd(state, add) {
    state.fromRouteAdd = add;
  },
  setfromRouteBiblio(state, is) {
    state.fromRouteBiblio = is;
  },
  pushAuteurs(state, s) {
    state.Auteurs.push(s);
  },
  resetAuteurs(state) {
    state.Auteurs = [];
  },
  pushThemes(state, s) {
    state.themes.push(s);
  },
  resetThemes(state) {
    state.themes = [];
  },

  updateDataCurrentSegment(state, data) {
    state.current.keyWords = data.keyWords;
    state.current.description = data.description;
    state.current.themes = data.Objectthemes;
    state.current.author = data.ObjectAuthor;
  },

  incrementPage(state, type) {
    state.currentPage[type] += 1;
  },
  setEndReached(state, { type, endReached }) {
    state.endReached[type] = endReached;
  },
  setSegmentsGeneric(state, slide) {
    let html = `<iframe class="gjs-no-pointer" src="${
      slide.src
    }?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>`;
    let extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = `<video data-autoplay class="gjs-no-pointer" data-src="${
        slide.src
      }" id="player-${Math.floor(Math.random() * 10) +
        Math.floor(
          Math.random() * 10,
        )}" width="100%" height="100%" scrolling="no" allow="encrypted-media" muted autoplay style="border: none; overflow: hidden;"></video>`;
    }
    let generic = {
      html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: durationHelper.totalSegmentDuration(),
      },
      screenShot: '',
      transition: { in: '', out: '' },
      ...slide,
    };
    let segment = {
      duration: generic.options.duration,
      screens: [generic],
      title: slide.title,
      type: slide.type,
    };
    let selected = state.selectedSegments.filter(s => s.type !== slide.type);
    if (segment.screens[0].src !== '') {
      if (generic.type.toLowerCase().includes('start')) {
        selected.unshift(segment);
      } else {
        selected.push(segment);
      }
    }
    selected = durationHelper.updateSegmentDuration(selected);
    state.selectedSegments = selected;
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  setSegmentsGenericFinEmpty(state, slide) {
    let selected = state.selectedSegments.filter(s => s.type == slide.type);
    if (selected[0] && selected[0].screens && selected[0].screens[0].src !== '') {
      state.selectedSegments.pop();
    }
    selected = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = selected;
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  setVideoIntro(state, slide) {
    let html = `<iframe class="gjs-no-pointer" src="${
      slide.src
    }?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>`;
    let extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = `<video data-autoplay class="gjs-no-pointer" src="${
        slide.src
      }" id="player-677" width="100%" height="100%" muted autoplay scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></video>`;
    }
    let generic = {
      html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: durationHelper.totalSegmentDuration(),
      },
      screenShot: '',
      transition: { in: '', out: '' },
      ...slide,
    };
    let index = +slide.index;

    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (i === index) {
        const transition = segment.screens[0].transition.in || '';
        if (transition) {
          generic.transition.in = transition;
          segment.screens[0].transition.in = '';
        }
        segment.screens = segment.screens.filter(s => s.type !== generic.type);
        if (generic.src !== '') {
          segment.screens.unshift(generic);
        }
        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
      }
      return segment;
    });
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  /* setSegmentDuration(state, data) {
    state.selected = state.selected.map(Segment => {
      if (Segment.id === data.id) {
        Segment.duration = data.duration;
      }
      return Segment;
    });
  },*/
  setCurrentSegmentDuration(state, duration) {
    state.current.duration = duration;
  },

  updateSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map((segment, index) => {
      if (segment.id === data.id) {
        state.selectedSegments[index].title = data.title || '';
        state.selectedSegments[index].duration = data.duration || '';
        state.selectedSegments[index].screensToSubmit = data.screensToSubmit || [];
      }
      return segment;
    });
  },

  deleteSegmentByIdStore(state, item) {
    state.segments = state.segments.filter(segment => segment.id !== item.id);
  },
  removeLastSegmentById(state, id) {
    state.selectedSegments = state.selectedSegments.filter((s, i) => s.id !== id);
  },
  existanceSlide(state, title) {
    HTTP(window.ApiToken)
      .get(Routing.generate('api_slideDisplay_get_existant_slide'), {
        title: title,
      })
      .then(function(response) {
        return response.data.existance;
      });
  },
  setCurrentSegment(state, current) {
    state.current = current;
  },
  updateSegmentThumbnail(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      segment.screens = segment.screens.map(screen => {
        if (screen.uid === data.uid) {
          screen.screenShot = data.thumbnail;
        }
        return screen;
      });
      return segment;
    });
  },
  updateSegmentListThumbnail(state, data) {
    state.segments = state.segments.map(segment => {
      segment.screens = segment.screens.map(screen => {
        if (screen.uid === data.uid) {
          screen.screenShot = data.thumbnail;
        }
        return screen;
      });
      return segment;
    });
  },
  updateSegmentTitleGlobally(state, data) {
    state.segments = state.segments.map(segment => {
      if (segment.id === data.id) {
        segment.title = data.title;
      }
      return segment;
    });
  },
  setSegmentTransition(state, data) {
    const transitionIndex = state.selectedSegments.findIndex(segment =>
      segment.screens.some(s => s.uid === data.uid),
    );

    state.selectedSegments = state.selectedSegments.map((segment, index) => {
      if (index === transitionIndex - 1) {
        segment = Object.assign({}, segment);
        segment.screens = segment.screens.map((s, i) => {
          if (i === segment.screens.length - 1) {
            s.transition.out = data.name + '-out';
          }
          return s;
        });
      } else if (index === transitionIndex) {
        segment = Object.assign({}, segment);
        segment.screens = segment.screens.map((s, i) => {
          if (i === 0) {
            s.transition.in = data.name + '-in';
          }
          return s;
        });
      }
      return segment;
    });
  },
  setIndexSegmentToAdd(state, index) {
    index += state.selectedSegments.findIndex(s => s.type === 'startGeneric') + 1;
    state.indexSegmentToAdd = index;
  },
  setLengthSegmentToAdd(state, index) {
    state.lengthSegmentToAdd = index;
  },
  setIndexSlideToAdd(state, index) {
    index += state.selectedSegments.findIndex(s => s.type === 'startGeneric') + 1;
    state.indexSlideToAdd = index;
  },
  setIndexSegmentSlideToAdd(state, index) {
    state.indexSegmentSlideToAdd = index;
  },
  appendSlideToSegment(state, slide) {
    const props = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      options: {
        duration: durationHelper.totalSegmentDuration(),
      },
      transition: {
        in: '',
        out: '',
      },
      js: slide.html.substring(slide.html.indexOf('<script>') + 8, slide.html.indexOf('</script>')),
      ...slide,
    };
    if (slide.type === 'images') {
      props.type = slide.type;
    } else {
      props.type = 'Screen';
    }

    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (i === state.indexSlideToAdd) {
        segment.screens.push(props);
        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
      }
      return segment;
    });
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },

  removeLastSlideFromSegmentById(state, id) {
    state.selectedSegments = state.selectedSegments.map((s, i) => {
      if (i === state.indexSlideToAdd) {
        const index = s.screens
          .slice()
          .reverse()
          .findIndex(slide => slide.id === id);
        const count = s.screens.length - 1;
        const finalIndex = index >= 0 ? count - index : index;
        s.screens = s.screens.filter((s, i) => i !== finalIndex);
      }
      return s;
    });
  },
  removeSlideFromSegmentByUid(state, { index, uid }) {
    let hasGeneric = state.selectedSegments.filter(segment =>
      segment.type.toLowerCase().includes('generic'),
    );
    index = hasGeneric.length > 0 ? index + 1 : index;
    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (i === index) {
        segment.screens = segment.screens.filter(s => s.uid !== uid);
        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
      }
      return segment;
    });

    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  updateSegmenScreentTitleGlobally(state, data) {
    state.segments.map(segment => {
      if (segment.screens.length !== 0) {
        let sc = segment.screens.filter(function(screen) {
          return screen.id === data.id;
        });

        if (sc.length !== 0) {
          sc[0].title = data.title;
        }
      }
    });
  },
  removeSegmentByUid(state, uid) {
    state.selectedSegments = state.selectedSegments.filter(segment => segment.uid !== uid);
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
  },
  duplicateSegment(state, { segment, index , type }) {
    const props = {
      title: segment.title + '(copie)',
      uid: new Date().valueOf(),
      type: 'Segment',
    };

    if(type === 'onescreen'){
      props.screens = segment.screens.map((slide, i) => {

        const props = {
          title: slide.title + '(copie)',
          uid: new Date().valueOf() + i,
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo,
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out,
          },
        };
        return Object.assign({}, JSON.parse(JSON.stringify(slide)), props);
      });
    }else {
      props.screens = segment.screens.map((slide, i) => {
        const props = {
          uid: new Date().valueOf() + i,
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo,
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out,
          },
        };
        return Object.assign({}, JSON.parse(JSON.stringify(slide)), props);
      });
    }

    state.selectedSegments.splice(
      index + 1,
      0,
      Object.assign({}, JSON.parse(JSON.stringify(segment)), props),
    );

    state.duplicatedSegment=Object.assign({}, JSON.parse(JSON.stringify(segment)), props);
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  setScreensTosubmitSegment(state, data) {
    state.segments.map(screen => {
      if (screen.id === data.id) {
        screen.template = data.template;
        screen.type = data.type;
        screen.options.transition = data.transition;
        screen.screenShot = data.screenShot;
      }
      return screen;
    });
  },
  duplicateBiblioSegment(state, { segment, index }) {
    let nb = 1;
    let indexOf = segment.title.search(/\(copie/i);
    let newTitel = '';
    if (indexOf !== -1) {
      let text = segment.title.substring(segment.title.length, indexOf);
      let originTiel = segment.title.substring(indexOf, 0);

      text = text.match(/\d/g);
      if (text && text !== '') nb += parseInt(text.join(''));

      newTitel = originTiel + '(copie' + nb + ')';
    }
    const props = {
      title: newTitel ? newTitel : segment.title + '(copie)',
      uid: new Date().valueOf(),
      type: 'DefaultSegment',
    };

    props.screens = segment.screens.map((slide, i) => {
      const props = {
        uid: new Date().valueOf() + i,
        options: {
          duration: slide.options.duration,
          fullscreenVideo: slide.options.fullscreenVideo ? slide.options.fullscreenVideo : false,
        },
        /* transition: {
          in: slide.transition.in ? slide.transition.in : '',
          out: slide.transition.out ? slide.transition.out : '',
        },*/
      };
      return Object.assign({}, JSON.parse(JSON.stringify(slide)), props);
    });
    state.segments.splice(index, 0, Object.assign({}, JSON.parse(JSON.stringify(segment)), props));
  },
  duplicateSlideInsideSegment(state, { slide, segmentIndex, slideIndex }) {
    state.selectedSegments = state.selectedSegments.map((segment, index) => {
      if (segmentIndex === index) {
        const props = {
          title: slide.title + '(copie)',
          uid: new Date().valueOf(),
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo,
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out,
          },
        };
        segment.screens.splice(
          slideIndex + 1,
          0,
          Object.assign({}, JSON.parse(JSON.stringify(slide)), props),
        );
        state.duplicatedSlideInSegment=Object.assign({}, JSON.parse(JSON.stringify(slide)), props);
        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
      }
      return segment;
    });
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  updateSlideInsideSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      segment.screens = segment.screens.map(s => {
        if (s.uid === data.uid) {
          s.components = data.components || '';
          s.html = data.html || '';
          s.css = data.css || '';
          s.styles = data.styles || '';
          s.js = data.js || '';
        }
        return s;
      });
      return segment;
    });
  },
  updateSegmentTitle(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      if (segment.uid === data.uid) {
        segment.title = data.title;
      }
      segment.screens = segment.screens.map(s => {
        if (s.uid === data.uid) {
          s.title = data.title;
        }
        return s;
      });
      return segment;
    });
  },
  updateFirstScreenSegmentTitle(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      if (segment.uid === data.uid) {

        segment.title = data.title;
        segment.screens = segment.screens.map(s => {
          s.title = data.title;
          return s;
        });
      }

      return segment;
    });
  },
  updateFullScreenVideoWithoutExtend(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      if (segment.uid === data.uid) {
        segment.withoutExtend = data.without;
      }
      return segment;
    });
  },
  updateSegmentDuration(state, { uid, duration, fullscreenVideo = false }) {
    state.selectedSegments = state.selectedSegments.map(s => {
      let segment = Object.assign({}, s);
      if (segment.uid === uid) {
        segment.duration = +duration;
        let generic = segment.screens.find(s => s.type.toLowerCase().includes('generic'));
        const length = segment.screens.length - (generic ? 1 : 0);

        if (generic && generic.options.duration) {
          if (!generic.originalDuration) {
            generic.originalDuration = generic.options.duration;
          }
          generic.options.duration = Math.min(generic.originalDuration, +duration);
          duration -= generic.options.duration;
        }

        segment.screens = segment.screens
          .filter(s => !s.type.toLowerCase().includes('generic'))
          .map((s, i) => {
            s.options.duration = Math.floor(+duration / length);
            if (i === length - 1) {
              s.options.duration += +duration % length;
            }
            return s;
          });
        if (generic) {
          segment.screens.unshift(generic);
        }
      } else {
        segment.screens = segment.screens.map((s, i) => {
          if (s.uid === uid) {
            s.options.duration = +duration;
            s.options.fullscreenVideo = fullscreenVideo;
          }
          return s;
        });
      }

      if (segment.screens.some(s => s.uid === uid)) {
        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
      }
      return segment;
    });
    durationHelper.updateSegmentDuration(state.selectedSegments);

    //durationHelper.updateSegmentDuration(state.selectedSegments);
  },
  toggleExtendSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(segment => {
      if (segment.uid === data.uid) {
        segment.isExtended = !segment.isExtended;
      }
      return segment;
    });
  },
  setNbrCall(state) {
    state.nbrCall = state.nbrCall + 1;
  },
  resetNbCall(state) {
    state.nbrCall = 1;
  },
  setTypeGeneric(state, src) {
    state.typeGeneric = src;
  },
  reorderSegments(state, { oldIndex, newIndex }) {
    const i = state.selectedSegments.findIndex(s => s.type === 'startGeneric') + 1;

    oldIndex += i;
    newIndex += i;

    const movedItem = state.selectedSegments.find((item, index) => index === oldIndex);
    const remainingItems = state.selectedSegments.filter((item, index) => index !== oldIndex);

    state.selectedSegments = [
      ...remainingItems.slice(0, newIndex),
      movedItem,
      ...remainingItems.slice(newIndex),
    ];
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  reorderSlidesInsideSegment(state, { event, index }) {
    let { oldIndex, newIndex } = event;

    const segmentIndex =
      index + state.selectedSegments.findIndex(s => s.type === 'startGeneric') + 1;
    const i =
      state.selectedSegments[segmentIndex].screens.findIndex(s => s.type === 'startGeneric') + 1;

    oldIndex += i;
    newIndex += i;

    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (i === segmentIndex) {
        const movedItem = segment.screens.find((item, index) => index === oldIndex);
        const remainingItems = segment.screens.filter((item, index) => index !== oldIndex);

        segment.screens = [
          ...remainingItems.slice(0, newIndex),
          movedItem,
          ...remainingItems.slice(newIndex),
        ];
      }
      return segment;
    });
  },
  appendCreatedSegment(state, data) {
    const date = new Date(data.segment.duration);
    const duration = Number.isInteger(data.segment.duration)
      ? data.segment.duration
      : Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        ) / 1000;
    const s = {
      ...data.segment,
      duration,
    };
    s.screens = s.screens.map(s => {
      return {
        transition:
          s.options.transition && Object.keys(s.options.transition).length > 0
            ? s.options.transition
            : { in: '', out: '' },
        options: {
          duration: durationHelper.totalSegmentDuration(),
        },
        ...s,
      };
    });


    state.segments.splice(
      data.index,
      0,
      s,
    );
  },
  removeBlankSlideToSegment(state, uid) {
    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(s => !s.type.toLowerCase().includes('blank'));
      }
      return segment;
    });
  },
  appendBlankSlideToSegment(state, uid) {
    const props = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      transition: {
        in: '',
        out: '',
      },
      js: '',
      options: {},
      assets: '',
      components: '',
      css: 'body{background-color:rgb(0, 0, 0);}',
      html: '',
      styles: '',
      title: 'blank',
      type: 'BlankSlide',
      screenShot:
        'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////2wBDAf//////////////////////////////////////////////////////////////////////////////////////wAARCAAJABADASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJgA/9k=',
      id: 0,
    };
    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(s => !s.type.toLowerCase().includes('blank'));
        // const fullscreenVideo = segment.screens.find(s => s.fullscreenVideo);
        let fullScreenIndex = segment.screens.findIndex(s => s.fullscreenVideo) + 1;
        if (fullScreenIndex > 0) {
          segment.duration = segment.screens.reduce(
            (sum, e) => sum + +(e.options.duration || 0),
            0,
          );

          props.options.duration = 30 - (segment.duration % 30);

          if (props.options.duration % 30 > 0) {
            segment.screens = [
              ...segment.screens.slice(0, fullScreenIndex),
              props,
              ...segment.screens.slice(fullScreenIndex),
            ];
            segment.duration += props.options.duration;
            segment.originalDuration = segment.duration;
          }
        }
      }
      return segment;
    });
    //state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    //state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  cropVideoFromSegment(state, uid) {
    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(s => !s.type.toLowerCase().includes('blank'));

        segment.duration = segment.screens.reduce((sum, e) => sum + +(e.options.duration || 0), 0);

        segment.screens = segment.screens.map(sc => {
          if (sc.fullscreenVideo) {
            sc.options.duration -= segment.duration % 30;
          }
          return sc;
        });
        segment.duration -= segment.duration % 30;
      }
      return segment;
    });
    state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  FixdurationVideoFromSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map((segment, i) => {
      if (segment.uid === data.uid) {
        segment.screens = segment.screens.filter(s => !s.type.toLowerCase().includes('blank'));
        segment.screens = segment.screens.map(sc => {
          if (sc.options.fullscreenVideo) {
            sc.withoutExtend = data.without;
          }
          return sc;
        });

        segment.originalDuration = data.duration;
        segment.fullscreenVideo = true;
      }
      return segment;
    });
    //state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
};

const actions = {
  async appendImageToSegment({ state, commit }, media) {
    function makeId() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    }
    let html =
      `<div data-gjs-type="image_media" id="` +
      makeId() +
      `" width="100%" height="100%"><image class="gjs-no-pointer" src="${
        media.selected.src
      }" id="image-media-` +
      makeId() +
      `" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>`;
    const domc = grapesjsEMP.editors[0].DomComponents;
    const defaultType = domc.getType('default');
    const defaultModel = defaultType.model;
    // const defaultView = defaultType.view;
    let components = {
      'custom-name': 'image',
      tagName: 'div',
      src: media.selected.src,
      width: '100%',
      height: '100%',
      resizable: false,
      selected: true,
      attributes: {
        id: +makeId(),
        'data-class': 'image-media',
      },
      classes: [
        {
          active: true,
          label: makeId(),
          name: makeId(),
          private: false,
          protected: false,
          type: 1,
        },
        {
          active: true,
          label: 'gjs-comp-selected',
          name: 'gjs-comp-selected',
          private: false,
          protected: false,
          type: 1,
        },
      ],
      type: '',
      draggable: true,
      droppable: false,
      editable: false,
      highlightable: true,
      hoverable: true,
      icon: '',
      layerable: true,
      name: '',
      propagate: '',
      removable: true,
      script: '',
      selectable: true,
      config: {
        translate: i18n.t('display-image-plugin'),
      },
      'data-class': 'image-media',
      badgable: true,
      components: [],
      content: '',
      copyable: true,
      state: '',
      status: '',
    };
    let fullscreenVideo = false;
    let slide = {
      html,
      type: media.type,
      components: JSON.stringify(components),
      css: '',
      js: '',
      options: { fullscreenVideo },
      screenShot: media.selected.src,
      transition: { in: '', out: '' },
      ...media.selected,
    };
    commit('appendSlideToSegment', slide);
  },

  async getTemplateById({ commit, dispatch }, id) {
    const url = Routing.generate('api_templateDisplay_get_template', {
      id: id,
      client: localStorage.getItem('client'),
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function(response) {
          resolve(response);
        });
    });

    data.template.segments.forEach(segment => {
      segment.isUpdate = true;
      commit('selectSegment', segment);
    });

    commit(
      'setCurrentSegment',
      state.selectedSegments.filter(s => !s.type.toLowerCase().includes('generic'))[0],
    );

    const screen = state.selectedSegments
      .filter(s => !s.type.toLowerCase().includes('generic'))[0]
      .screens.filter(s => !s.type.toLowerCase().includes('generic'))[0];
    let totalDuration = 0;
    data.template.segments.forEach(s => {
      const date = new Date(s.duration);

      const duration = Number.isInteger(s.duration)
        ? s.duration
        : Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
          ) / 1000;
      totalDuration += duration;
    });

    let templateToEdit = {
      ...data.template,
      duration: totalDuration,
    };
    dispatch('slides/setTemplate', templateToEdit, { root: true });
    dispatch('slides/setCurrentSlide', screen, { root: true });
  },

  async getAuteurs({ commit }) {
    commit('resetAuteurs');

    const url = Routing.generate('api_media_get_contributors');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function(response) {
          resolve(response);
        });
    });

    let Auteurs = data.contributors;
    Auteurs.map(Auteur => {
      commit('pushAuteurs', Auteur);
    });
  },

  async getSegment({ commit }, id) {
    const url = Routing.generate('api_segmentDisplay_get_one_segments', {
      id: id,
      client: localStorage.getItem('client'),
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function(response) {
          resolve(response);
        });
    });

    commit('setCurrentSegment', data);
  },

  async setThemes({ commit }) {
    commit('resetThemes');
    const url = Routing.generate('api_parameters_get_themes_children_per_canal', {
      type: 'segment',
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function(response) {
          resolve(response);
        });
    });

    let themes = data.subThemesList;
    if (themes && themes.length > 0) {
      themes.map(theme => {
        commit('pushThemes', theme);
      });
    }
  },
  async deleteOneSegmentById({ commit }, item) {
    HTTP(window.ApiToken)
      .delete(Routing.generate('api_segmentDisplay_delete_one', { id: item.id }))
      .then(function(response) {});
  },
  async duplicateSegmentInDataBase({ state, commit }, data) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_segmentDisplay_post_duplicate_segment', { id: data.id }), {
        title: data.title,
        author: data.author,
        keyWords: data.keyWords,
        description: data.description,
        themes: data.themes,
      })
      .then(function(response) {});
  },
  async paginatesegment({ commit }, type) {
    if (!state.endReached[type]) {
      let DefParam = '{"duration":20,"transition":{in: "", out: ""}';
      self = this;
      commit('setLoading', true);
      let nbPage = state.nbPerPage;
      var query = {
        page: state.currentPage[type],
        nbParPage: nbPage,
        type: type,
        client: localStorage.getItem('client'),
      };
      if (state.title) {
        query.title = state.title;
      }
      if (state.theme) {
        query.theme = state.theme;
      }
      if (state.author) {
        query.author = state.author;
      }
      const url = Routing.generate('api_segmentDisplay_get_list_segments', query);
      commit('incrementPage', type);
      const { data } = await new Promise((resolve, reject) => {
        HTTP(window.ApiToken)
          .get(url)
          .then(function(response) {
            resolve(response);
            if (!state.fromRouteAdd) eventHub.$emit('stopProgress');
          });
      });

      // if  duration of segment Null  Default 20s
      data.data.segments.map(onesegment => {
        if (onesegment.duration == null) {
          onesegment.duration = '1970-01-01T00:00:20+0100';
        }
      });

      data.data.segments.flatMap(({ screens }) => {
        return screens.map(screen => {
          screen.options = JSON.parse(screen.options);

          //if screen.options null Default value
          if (screen.options == null) {
            screen.options = JSON.parse(DefParam);
          }
          if(typeof screen.options === "string"){
            screen.options = JSON.parse(screen.options)
          }
          if (screen.options.duration == null) {
            screen.options.duration = 20;
          }
          if (screen.options.transition == null) {
            screen.options.transition = { in: '', out: '' };
          }
        });
      });

      commit('pushSegments', data.data.segments);
      commit('nbSegments', data.data.nombre_total);
      commit('setLoading', false);

      if (data.data.segments.length < state.nbPerPage) {
        commit('setEndReached', { type, endReached: true });
      } else {
        commit('setEndReached', { type, endReached: false });
      }

      if (data.data.segments.length < 1) eventHub.$emit('notFound', true);
      else eventHub.$emit('notFound', false);

      commit('setLoading', false);
    }
  },
  async updateTitleSegment({ state, commit }, data) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_segmentDisplay_post_edit_title_segment', { id: data.id }), {
        title: data.title,
      })
      .then(function(response) {
        commit('updateSegmentTitleGlobally', data);
      });
  },
  async updateMetadataSegment({ state, commit }, data) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_segmentDisplay_post_edit_title_segment', { id: data.id }), {
        title: data.title,
        author: data.author,
        keyWords: data.keyWords,
        description: data.description,
        themes: data.themes,
      })
      .then(function(response) {
        commit('updateDataCurrentSegment', data);

        commit('updateSegmentTitleGlobally', data);
      });
  },

  async updateTitleScreenInSegment({ state, commit }, data) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_screenDisplay_post_edit_screen', { id: data.id }), {
        title: data.title,
      })
      .then(function(response) {
        commit('updateSegmenScreentTitleGlobally', data);
      });
  },
  setScreensTosubmitSegment: ({ state, commit }, data) => commit('setScreensTosubmitSegment', data),
  setEndReached: ({ state, commit }, data) => commit('setEndReached', data),

  deleteSegmentByIdStore: ({ state, commit }, item) => commit('deleteSegmentByIdStore', item),
  updateFullScreenVideoWithoutExtend: ({ state, commit }, without) =>
    commit('updateFullScreenVideoWithoutExtend', without),
  updateSegmentTitleInStore: ({ state, commit }, Segment) =>
    commit('updateSegmentTitleInStore', Segment),
  setSegments: ({ state, commit }, segments) => commit('setSegments', segments),
  selectSegment: ({ state, commit }, segment) => commit('selectSegment', segment),
  setCurrentSegment: ({ state, commit }, segment) => commit('setCurrentSegment', segment),
  //setSegmentDuration: ({ state, commit }, segment) => commit('setSegmentDuration', segment),
  updateSegment: ({ state, commit }, segment) => commit('updateSegment', segment),
  updateSegmentThumbnail: ({ state, commit }, segment) => commit('updateSegmentThumbnail', segment),
  updateSegmentListThumbnail: ({ state, commit }, segment) => commit('updateSegmentListThumbnail', segment),
  removeSegmentByUid: ({ state, commit }, uid) => commit('removeSegmentByUid', uid),
  removeLastSegmentById: ({ state, commit }, id) => commit('removeLastSegmentById', id),
  pushSegments: ({ state, commit }, segment) => commit('pushSegments', segment),
  cancelDelete: ({ state, commit }, data) => commit('cancelDelete', data),
  setTitle: ({ state, commit }, title) => commit('setTitle', title),
  setThemeid: ({ state, commit }, id) => commit('setThemeid', id),
  setAuthorid: ({ state, commit }, id) => commit('setAuthorid', id),
  setCurrentSegmentDuration: ({ state, commit }, duration) =>
    commit('setCurrentSegmentDuration', duration),
  resetPage({ state, commit }, types) {
    commit('resetPage', types);
  },
  setSegmentsGeneric: ({ state, commit }, slide) => commit('setSegmentsGeneric', slide),
  setSegmentsGenericFinEmpty: ({ state, commit }, slide) =>
    commit('setSegmentsGenericFinEmpty', slide),
  setVideoIntro: ({ state, commit }, slide) => commit('setVideoIntro', slide),
  setSegmentTransition: ({ state, commit }, slide) => commit('setSegmentTransition', slide),
  setIndexSegmentToAdd: ({ state, commit }, index) => commit('setIndexSegmentToAdd', index),
  setLengthSegmentToAdd: ({ state, commit }, index) => commit('setLengthSegmentToAdd', index),
  setIndexSlideToAdd: ({ state, commit }, index) => commit('setIndexSlideToAdd', index),
  setIndexSegmentSlideToAdd: ({ state, commit }, index) =>
    commit('setIndexSegmentSlideToAdd', index),
  appendSlideToSegment: ({ state, commit }, slide) => commit('appendSlideToSegment', slide),
  removeLastSlideFromSegmentById: ({ state, commit }, slide) =>
    commit('removeLastSlideFromSegmentById', slide),
  removeSlideFromSegmentByUid: ({ state, commit }, data) =>
    commit('removeSlideFromSegmentByUid', data),
  duplicateSegment: ({ state, commit }, data) => commit('duplicateSegment', data),
  duplicateBiblioSegment: ({ state, commit }, data) => commit('duplicateBiblioSegment', data),
  duplicateSlideInsideSegment: ({ state, commit }, data) =>
    commit('duplicateSlideInsideSegment', data),
  updateSlideInsideSegment: ({ state, commit }, data) => commit('updateSlideInsideSegment', data),
  updateSegmentTitle: ({ state, commit }, data) => commit('updateSegmentTitle', data),
  updateFirstScreenSegmentTitle: ({ state, commit }, data) => commit('updateFirstScreenSegmentTitle', data),
  resetNbCall: ({ state, commit }) => commit('resetNbCall'),
  updateSegmentDuration: ({ state, commit }, data) => commit('updateSegmentDuration', data),
  toggleExtendSegment: ({ state, commit }, data) => commit('toggleExtendSegment', data),
  setNbrCall: ({ state, commit }) => commit('setNbrCall'),
  setTypeGeneric: ({ state, commit }, src) => commit('setTypeGeneric', src),
  appendCreatedSegment: ({ state, commit }, segment) => commit('appendCreatedSegment', segment),
  appendBlankSlideToSegment: ({ state, commit }, uid) => commit('appendBlankSlideToSegment', uid),
  removeBlankSlideToSegment: ({ state, commit }, uid) => commit('removeBlankSlideToSegment', uid),
  cropVideoFromSegment: ({ state, commit }, uid) => commit('cropVideoFromSegment', uid),
  FixdurationVideoFromSegment: ({ state, commit }, data) =>
    commit('FixdurationVideoFromSegment', data),
  reorderSegments: ({ state, commit }, event) => commit('reorderSegments', event),
  reorderSlidesInsideSegment: ({ state, commit }, data) =>
    commit('reorderSlidesInsideSegment', data),
  setCurrentSegmentTitle: ({ state, commit }, title) => commit('setCurrentSegmentTitle', title),
  setfromRouteAdd: ({ state, commit }, add) => commit('setfromRouteAdd', add),
  setfromRouteBiblio: ({ state, commit }, add) => commit('setfromRouteBiblio', add),
  pushModuleSelected: ({ state, commit }, data) => commit('pushModuleSelected', data),
  restModuleSelected: ({ state, commit }) => commit('restModuleSelected'),
  removeFromModuleSelected: ({ state, commit }, id) => commit('removeFromModuleSelected', id),

  async selectMedias({ state, commit }, media) {
    function makeId() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    }
    let html =
      `<div data-gjs-type="image_media" id="` +
      makeId() +
      `" width="100%" height="100%"><image class="gjs-no-pointer" src="${
        media.selected.src
      }" id="image-media-` +
      makeId() +
      `" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>`;
    const domc = grapesjsEMP.editors[0].DomComponents;
    const defaultType = domc.getType('default');
    const defaultModel = defaultType.model;
    // const defaultView = defaultType.view;
    let components = {
      'custom-name': 'image',
      tagName: 'div',
      src: media.selected.src,
      width: '100%',
      height: '100%',
      resizable: false,
      selected: true,
      attributes: {
        id: +makeId(),
        'data-class': 'image-media',
      },
      classes: [
        {
          active: true,
          label: makeId(),
          name: makeId(),
          private: false,
          protected: false,
          type: 1,
        },
        {
          active: true,
          label: 'gjs-comp-selected',
          name: 'gjs-comp-selected',
          private: false,
          protected: false,
          type: 1,
        },
      ],
      type: '',
      draggable: true,
      droppable: false,
      editable: false,
      highlightable: true,
      hoverable: true,
      icon: '',
      layerable: true,
      name: '',
      propagate: '',
      removable: true,
      script: '',
      selectable: true,
      config: {
        translate: i18n.t('display-image-plugin'),
      },
      'data-class': 'image-media',
      badgable: true,
      components: [],
      content: '',
      copyable: true,
      state: '',
      status: '',
    };
    if (media.type === 'videos') {
      html =
        `<iframe data-gjs-type="video_mp4" class="gjs-no-pointer" src="${
          media.selected.src
        }?a=1&sc=0" id="player-mp4-` +
        makeId() +
        `" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>`;
      let extension = media.selected.src.split('.').pop();
      if (extension.toLowerCase().indexOf('mp4') > -1) {
        html =
          `<video  data-gjs-type="video_mp4" class="gjs-no-pointer" src="${
            media.selected.src
          }" id="player-mp4-` +
          makeId() +
          `" width="100%" height="100%"  scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></video>`;
      }
      components.tagName = 'video';
      components.type = 'video_mp4';
      components.config.translate = i18n.t('display-player-mp4-plugin');
      components['custom-name'] = 'video_mp4';
      components.attributes = {
        autoplay: '1',
        id: makeId(),
        muted: true,
        src: media.selected.src,
        width: '100%',
        height: '100%',
      };
      components.autoplay = '1';
      components.muted = true;
      components['data-class'] = 'player-mp4';
      components.duration = media.selected.duration;
    }
    let fullscreenVideo = false;
    if (media.type == 'videos') {
      fullscreenVideo = true;
    }
    let slide = {
      html,
      type: media.type,
      components: JSON.stringify(components),
      css: '',
      js: '',
      options: { fullscreenVideo },
      screenShot: media.selected.src,
      transition: { in: '', out: '' },
      ...media.selected,
    };

    let segment = {
      screens: [slide],
      title: media.selected.title,
      description: media.selected.description,
      author: media.selected.auteur,
      type: 'Segment',
      id: media.selected.id,
      duration: media.selected.duration,
    };

    commit('selectSegment', segment);
    commit('pushModuleSelected', segment);

  },
};

// getters are functions
const getters = {
  getduplicatedSegment: state => state.duplicatedSegment,
  getduplicatedSlideInSegment: state => state.duplicatedSlideInSegment,
  getAuteursList: state => state.Auteurs,
  getModuleSelected: state => state.moduleSelected,
  getThemesList: state => state.themes,

  getFromRouteAdd: state => state.fromRouteAdd,
  getFromRouteBiblio: state => state.fromRouteBiblio,
  getLoading: state => state.loading,
  getEndReached: state => type => state.endReached[type],
  getSegments: state => state.segments,
  getSelectedSegments: state =>
    state.selectedSegments.filter(segment => !segment.type.toLowerCase().includes('generic')),
  getAllSelected: state => state.selectedSegments,
  isSelectedSegment: state => segment => state.selectedSegments.some(s => s.id === segment.id),
  getSegmentById: state => id => state.selectedSegments.find(item => item.id === id),
  getLastSegmentById: state => id =>
    state.selectedSegments
      .slice()
      .reverse()
      .find(slide => slide.id === id),
  getCurrent: state => state.current,
  getApercu: state => state.current,

  getByIndex: state => index => state.selectedSegments.find((s, i) => i === index),
  getAllSegments: state => state.segments.filter(s => s.type === 'Segment'),
  getAllDefaultSegments: state => state.segments.filter(s => s.type === 'DefaultSegment'),
  getStartGeneric: state => state.selectedSegments.find(s => s.type === 'startGeneric'),
  getFinishGeneric: state => state.selectedSegments.find(s => s.type === 'finishGeneric'),
  getAllSelectedSlides: state => {
    let slides = [];
    state.selectedSegments.forEach(segment => {
      if (segment.screens && segment.screens.length > 0) {
        segment.screens.forEach(screen => {
          slides.push(screen);
        });
      }
    });
    return slides;
  },
  getDeletedSegmentIndex: state => segment => state.segments.findIndex(s => s.id === segment.id),

  getSegmentIndex: state => segment =>
    state.selectedSegments
      .filter(segment => !segment.type.toLowerCase().includes('generic'))
      .findIndex(s => s.uid === segment.uid),
  getAllSegmentsDuration: state =>
    state.selectedSegments.reduce((sum, e) => sum + +(e.duration || 0), 0),
  getSlideByUid: state => uid => {
    let slide = {};
    state.selectedSegments.forEach(segment => {
      if (segment.uid === uid) {
        slide = Object.assign({}, segment);
      }
      segment.screens.forEach(screen => {
        if (screen.uid === uid) {
          slide = Object.assign({}, screen);
        }
      });
    });
    return slide;
  },
  getByUid: state => uid =>
    state.selectedSegments.find(sg => sg.uid === uid || sg.screens.some(sc => sc.uid === uid)),
  hasFullscreenVideo: state => uid =>
    state.selectedSegments.some(
      sg =>
        sg.screens.some(sc => sc.fullscreenVideo) &&
        (sg => sg.uid === uid || sg.screens.some(sc => sc.uid === uid)),
    ),
  getNbrCall: state => state.nbrCall,
  getTypeGeneric: state => state.typeGeneric,
  isExtended: state => uid => {
    const segment = state.selectedSegments.find(s => s.uid === uid);
    return segment && segment.isExtended;
  },
  getLastUpdatedSegment: state =>
    state.selectedSegments.find((s, i) => i === state.indexSlideToAdd),
  getLastUpdatedSegmentById: state =>
    state.selectedSegments.find((s, i) => s.id === state.indexSegmentSlideToAdd),
  getCurrentPage: state => type => state.currentPage[type],
  getNbSegments: state => state.nbSegments,
  getLengthSegmentToAdd: state => state.lengthSegmentToAdd,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/segments-data.js